import type * as api from '@gitbook/api-client';
import type { PaletteGroupDef } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { filterOutNullable } from '@gitbook/util-ts';

import type { NavigateFunction } from '../../../navigation';
import { getSpaceLanguageCommands } from '../../Space';

/**
 * Palette options relating to space management.
 */
export function getPaletteSpaceOptions(props: {
    space: api.Space;
    navigate: NavigateFunction;
}): PaletteGroupDef {
    const { space, navigate } = props;
    return {
        key: 'space-options',
        commands: [
            {
                key: 'view',
                title: 'Go to space',
                icon: Icon.Space,
                trigger: () => {
                    navigate({
                        screen: {
                            type: 'space',
                            space: space.id,
                            organization: space.organization,
                            page: '',
                            query: undefined,
                        },
                    });
                },
            },
            getSpaceLanguageCommands(space),
        ].filter(filterOutNullable),
    };
}
